export default "__VITE_ASSET__CJ49K8nI__"